import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

import './index.scss';
import styled from 'styled-components';

const emptyOptions = [
    {
        label: 'Please Select',
        value: null,
    },
];

const ErrorWrapper = styled.span`
    color: #f00;
    display: block;
    font-size: 12px;
    margin: 8px 0;
    /* text-transform: capitalize; */
`;

const SearchSelect = props => {
    const {
        input,
        data,
        valueField,
        labelField,
        id,
        label,
        meta,
        isDisabled,
        handleSearchEnd = () =>{},
        entityType,
        autoSelected
    } = props;

    const [finalOptions, setFinalOptions] = useState(emptyOptions);

    const selectedOption = finalOptions.find(
        option => option.value === input.value
    ) || 
    (autoSelected && {
        label: autoSelected.labelField,
        value: autoSelected.valueField
    });

    const handleChange = option => {
        input.onChange(option.value);
    };

    const handleBlur = () => {
        input.onBlur(input.value);
    };

    // Handle Backspace key to clear selected option
    const handleKeyDown = (event) => {
        if (event.key === 'Backspace' && input.value) {
            input.onChange(null); // Clear selected option
        }
    };

    const selectProps = {
        ...input,
        options: finalOptions,
        id,
        label,
        onChange: handleChange,
        onBlur: handleBlur,
        getOptionLabel: option => option.label,
        getOptionValue: option => option.value,
        isDisabled,
        onKeyDown: handleKeyDown
    };

    if (!selectedOption && label) {
        selectProps.placeholder = label;
    } else {
        selectProps.value = selectedOption;
    }

    useEffect(() => {
        const finalOptionsTemp = [{ label, value: null }].concat(
            data.map(option => {
                return { label: option[labelField], value: option[valueField] };
            })
        );
        setFinalOptions(finalOptionsTemp);
        // ✅ Auto-select if `autoSelected` is passed and input is empty
        if (autoSelected && !input.value) {
            input.onChange(autoSelected.valueField);
        }
    }, [labelField, data, valueField, label]);

    return (
        <div className="search-select-wrapper">
            <Select {...selectProps} classNamePrefix='search-select' onInputChange={(value) => handleSearchEnd(value, entityType)} />
            {meta.touched && meta.error && <ErrorWrapper className='error-message'>{meta.error}</ErrorWrapper>}
        </div>
    );
};

SearchSelect.propTypes = {
    valueField: PropTypes.string,
    labelField: PropTypes.string,
    className: PropTypes.string,
    data: PropTypes.object,
    input: PropTypes.node,
    id: PropTypes.string,
    label: PropTypes.string,
    meta: PropTypes.object,
};

export default SearchSelect;
